import { Assign, AssignForm } from "../types/types";
import { get, post } from "../util/api";

/**
 * 全てのアサインを取得
 */
export const findAllAssigns = async (): Promise<Assign[]> => {
  return await get<Assign[]>("/assigns");
};

/**
 * 年期でアサインを検索
 */
export const findAssignsByNenki = async (nenki: string): Promise<Assign[]> => {
  return await get<Assign[]>("/assigns", { nenki });
};

/**
 * アサインを保存
 * @param assignForms
 */
export const saveAssigns = async (assignForms: AssignForm[]) => {
  return await post("/assigns", assignForms);
};
